'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var _regeneratorRuntime = _interopDefault(require('@babel/runtime/regenerator'));
var effects = require('redux-saga/effects');
var Apollo = require('@engaging-tech/graphql');
var Apollo__default = _interopDefault(Apollo);
var ssrConfig = require('@engaging-tech/ssr-config');
var _taggedTemplateLiteralLoose = _interopDefault(require('@babel/runtime/helpers/taggedTemplateLiteralLoose'));
var reselect = require('reselect');
var frontendUtils = require('@engaging-tech/frontend-utils');
var reactRedux = require('react-redux');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var components = require('@engaging-tech/components');
var routing = require('@engaging-tech/routing');
var _objectWithoutPropertiesLoose = _interopDefault(require('@babel/runtime/helpers/objectWithoutPropertiesLoose'));
var charts = require('@engaging-tech/charts');
var dateFns = require('date-fns');

var types = {
  LOAD_REPORT: "[Happiness] Load Report",
  LOAD_REPORT_SUCCESS: "[Happiness] Load Report Success",
  LOAD_REPORT_FAIL: "[Happiness] Load Report Fail",
  LOAD_RANKINGS: "[Happiness] Load Rankings",
  LOAD_RANKINGS_SUCCESS: "[Happiness] Load Rankings Success",
  LOAD_RANKINGS_FAIL: "[Happiness] Load Rankings Fail"
};
var loadReport = function loadReport() {
  return {
    type: types.LOAD_REPORT
  };
};
var loadReportSuccess = function loadReportSuccess(_ref) {
  var worldwide = _ref.worldwide,
      countries = _ref.countries,
      industries = _ref.industries;
  return {
    type: types.LOAD_REPORT_SUCCESS,
    payload: {
      worldwide: worldwide,
      countries: countries,
      industries: industries
    }
  };
};
var loadReportFail = function loadReportFail() {
  return {
    type: types.LOAD_REPORT_FAIL
  };
};
var loadRankings = function loadRankings() {
  return {
    type: types.LOAD_RANKINGS
  };
};
var loadRankingsSuccess = function loadRankingsSuccess(rankings) {
  return {
    type: types.LOAD_RANKINGS_SUCCESS,
    payload: rankings
  };
};
var loadRankingsFail = function loadRankingsFail() {
  return {
    type: types.LOAD_RANKINGS_FAIL
  };
};

var happiness_actions = /*#__PURE__*/Object.freeze({
  types: types,
  loadReport: loadReport,
  loadReportSuccess: loadReportSuccess,
  loadReportFail: loadReportFail,
  loadRankings: loadRankings,
  loadRankingsSuccess: loadRankingsSuccess,
  loadRankingsFail: loadRankingsFail
});

var initialState = {
  isLoading: false,
  report: {
    worldwide: null,
    industries: {},
    countries: {}
  },
  rankings: [{
    reportId: {},
    scores: {}
  }],
  headings: ["Ranking", "Industry", "Country", "Likely to recommend to a friend", "Happiness Score"]
};
var reducer = function reducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case types.LOAD_RANKINGS:
    case types.LOAD_REPORT:
      return _extends({}, state, {
        isLoading: true
      });

    case types.LOAD_REPORT_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        report: {
          worldwide: action.payload.worldwide,
          industries: action.payload.industries,
          countries: action.payload.countries
        }
      });

    case types.LOAD_RANKINGS_FAIL:
    case types.LOAD_REPORT_FAIL:
      return _extends({}, state, {
        isLoading: false
      });

    case types.LOAD_RANKINGS_SUCCESS:
      return _extends({}, state, {
        isLoading: false,
        rankings: action.payload
      });

    default:
      return state;
  }
};

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  query($minSubmissions: Int) {\n    getIndustryByCountryScores(minSubmissions: $minSubmissions) {\n      reportId {\n        industryId\n        countryId\n      }\n      scores {\n        avgHappiness\n        avgRecommendation\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  query {\n    getOverallHappinessScores {\n      global\n      industries {\n        industry {\n          name\n        }\n        happinessScore\n      }\n      countries {\n        country {\n          name\n        }\n        happinessScore\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var LOAD = Apollo.gql(_templateObject());
var GET_INDUSTRY_COUNTRY_RANKING = Apollo.gql(_templateObject2());

var apollo = new Apollo__default();

var GRAPHQL_API_URL = function GRAPHQL_API_URL() {
  return "" + ssrConfig.getConfig().api.url + ssrConfig.getConfig().api.endpoints.graphql;
};

var load = function load() {
  return apollo.query({
    uri: GRAPHQL_API_URL,
    query: LOAD
  });
};
var getIndustryByCountryRanking = function getIndustryByCountryRanking() {
  return apollo.query({
    uri: GRAPHQL_API_URL,
    query: GET_INDUSTRY_COUNTRY_RANKING,
    variables: {
      minSubmissions: 10
    }
  });
};

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(loadHappiness),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(loadIndustryRankings),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(saga);
function loadHappiness(action, api) {
  var res, _res$data$getOverallH, countries, industries, worldwide;

  return _regeneratorRuntime.wrap(function loadHappiness$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (api === void 0) {
            api = load;
          }

          _context.next = 3;
          return effects.call(api);

        case 3:
          res = _context.sent;
          _context.prev = 4;
          _res$data$getOverallH = res.data.getOverallHappinessScores, countries = _res$data$getOverallH.countries, industries = _res$data$getOverallH.industries, worldwide = _res$data$getOverallH.global;
          _context.next = 8;
          return effects.put(loadReportSuccess({
            worldwide: worldwide,
            countries: countries,
            industries: industries
          }));

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](4);
          _context.next = 14;
          return effects.put(loadReportFail());

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[4, 10]]);
}
function loadIndustryRankings(action, api) {
  var res, rankings;
  return _regeneratorRuntime.wrap(function loadIndustryRankings$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (api === void 0) {
            api = getIndustryByCountryRanking;
          }

          _context2.next = 3;
          return effects.call(api);

        case 3:
          res = _context2.sent;
          _context2.prev = 4;
          rankings = res.data.getIndustryByCountryScores;
          _context2.next = 8;
          return effects.put(loadRankingsSuccess(rankings));

        case 8:
          _context2.next = 14;
          break;

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](4);
          _context2.next = 14;
          return effects.put(loadRankingsFail());

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[4, 10]]);
}
function saga() {
  return _regeneratorRuntime.wrap(function saga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return effects.takeLatest(types.LOAD_REPORT, loadHappiness);

        case 2:
          _context3.next = 4;
          return effects.takeLatest(types.LOAD_RANKINGS, loadIndustryRankings);

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

var worldwideHappiness = function worldwideHappiness(state) {
  return state.happiness.report.worldwide;
};

var countriesHappiness = function countriesHappiness(state) {
  return state.happiness.report.countries;
};

var industriesHappiness = function industriesHappiness(state) {
  return state.happiness.report.industries;
};

var rankings = function rankings(state) {
  return state.happiness.rankings;
};

var headings = function headings(state) {
  return state.happiness.headings;
};

var flattenScores = function flattenScores(scoreList, type) {
  return Object.keys(scoreList).map(function (scoreItemId) {
    return {
      id: scoreItemId,
      name: scoreList[scoreItemId][type].name,
      overall: parseInt(scoreList[scoreItemId].happinessScore * 100, 10)
    };
  });
};

var findDefaultCountry = function findDefaultCountry(state, props) {
  var countries = flattenScores(state.happiness.report.countries, "country");
  return countries.find(function (country) {
    return country.name === props.defaultCountry;
  });
};

var findDefaultIndustry = function findDefaultIndustry(state, props) {
  var industries = flattenScores(state.happiness.report.industries, "industry");
  return industries.find(function (industry) {
    return industry.name === props.defaultIndustry;
  });
};

var findIndustryById = function findIndustryById(state, props) {
  return frontendUtils.pipe(function () {
    return flattenScores(state.happiness.report.industries, "industry");
  }, function (industries) {
    return industries.find(function (industry) {
      return industry.id === props.id;
    });
  }, function (found) {
    return found ? {
      name: found.name,
      overall: found.overall
    } : null;
  })(state, props);
};

var sortAlphabetically = function sortAlphabetically(a, b) {
  return a.name < b.name ? -1 : 1;
};

var sortByHappinessScore = function sortByHappinessScore(a, b) {
  return a.scores.avgHappiness < b.scores.avgHappiness ? 1 : -1;
};

var mapRankings = function mapRankings(rankingList) {
  var sortedRankings = rankingList.filter(function (rank) {
    return !frontendUtils.isOther(rank.reportId.industryId);
  }).sort(sortByHappinessScore);
  return sortedRankings.map(function (rank, index) {
    var _rank$reportId = rank.reportId,
        industryId = _rank$reportId.industryId,
        countryId = _rank$reportId.countryId;
    var recommendationPerc = rank.scores.avgRecommendation * 10; // recommendation is from 0 to 10

    return [index + 1, industryId, countryId, parseFloat(recommendationPerc).toFixed(0) + "%", parseFloat(rank.scores.avgHappiness * 100).toFixed(0) + "%"];
  });
};

var getWorldWide = reselect.createSelector(worldwideHappiness, function (worldwide) {
  return worldwide && parseInt(worldwide * 100, 10);
});
var getCountries = reselect.createSelector(countriesHappiness, function (countries) {
  return flattenScores(countries, "country").sort(sortAlphabetically);
});
var getCountry = reselect.createSelector(findDefaultCountry, function (country) {
  return country;
});
var getIndustries = reselect.createSelector(industriesHappiness, function (industries) {
  return flattenScores(industries, "industry").sort(sortAlphabetically);
});
var getIndustry = reselect.createSelector(findDefaultIndustry, function (industry) {
  return industry && industry;
});
var getIndustryById = reselect.createSelector(findIndustryById, function (industry) {
  return industry;
});
var getHeadings = reselect.createSelector(headings, function (headingsList) {
  return headingsList;
});
var getRankings = reselect.createSelector(rankings, function (rankingList) {
  return mapRankings(rankingList);
});

var happiness_selectors = /*#__PURE__*/Object.freeze({
  getWorldWide: getWorldWide,
  getCountries: getCountries,
  getCountry: getCountry,
  getIndustries: getIndustries,
  getIndustry: getIndustry,
  getIndustryById: getIndustryById,
  getHeadings: getHeadings,
  getRankings: getRankings
});

var toPercentage = function toPercentage(score) {
  return score ? Math.round(score) + "%" : 0 + "%";
};

var Score = function Score(_ref) {
  var current = _ref.current,
      isGlobal = _ref.isGlobal,
      props = _objectWithoutPropertiesLoose(_ref, ["current", "isGlobal"]);

  return React__default.createElement(components.Flex, _extends({
    alignItems: "center",
    justifyContent: "space-between",
    p: 3,
    borderRadius: 4,
    elevation: 2,
    bg: "light.0"
  }, props), React__default.createElement(components.Text, {
    fontSize: "2",
    color: "dark.2",
    width: "inherit"
  }, isGlobal ? "Global average happiness score" : "Average score"), React__default.createElement(components.Flex, {
    width: "auto"
  }, React__default.createElement(components.Text, {
    fontSize: "3",
    color: "dark.2",
    fontWeight: "600",
    mr: 1
  }, toPercentage(current))));
};

var icon = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2222.667%22%20height%3D%2222.667%22%20viewBox%3D%220%200%2022.667%2022.667%22%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill%3Argba%280%2C0%2C0%2C0.6%29%3B%7D.b%7Bfill%3Anone%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20transform%3D%22translate%280%29%22%3E%3Cpath%20class%3D%22a%22%20d%3D%22M7%2C10l6.3%2C6.3%2C6.3-6.3Z%22%20transform%3D%22translate%28-1.963%20-1.384%29%22%2F%3E%3Cpath%20class%3D%22b%22%20d%3D%22M0%2C0H22.667V22.667H0Z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  border: none;\n  appearance: none;\n  width: 100%;\n  padding: ", "px 48px\n    ", "px ", "px;\n  background-image: url(", ");\n  background-position: center right ", "px;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  font-size: ", "px;\n  color: ", ";\n  border-radius: 4px 4px 0 0;\n  text-overflow: ellipsis;\n  margin: 0;\n\n  @media (min-width: ", "px) {\n    font-size: ", "px;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var Select = styled__default.select(_templateObject$1(), function (_ref) {
  var theme = _ref.theme;
  return theme.space[3];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space[3];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space[3];
}, icon, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space[3];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.dark[7];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes[4];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.dark[2];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints[0];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes[3];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.dark[5];
});
/**
 * Renders a invisible form field label. The labels can't be seen,
 * but will be read out by a screen reader for visitors who use
 * assistive technologies.
 */

var HiddenLabel = styled__default.label(_templateObject2$1());

var Dropdown = function Dropdown(_ref11) {
  var type = _ref11.type,
      _onChange = _ref11.onChange,
      items = _ref11.items,
      selectedItem = _ref11.selectedItem,
      defaultValue = _ref11.defaultValue;
  return React__default.createElement(components.Box, {
    bg: "light.0",
    mb: 2,
    borderRadius: 4
  }, React__default.createElement(HiddenLabel, {
    htmlFor: type
  }, "Select ", type, ":"), React__default.createElement(Select, {
    key: defaultValue,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    id: "dropdown-" + type,
    defaultValue: defaultValue && defaultValue.id
  }, items.map(function (item) {
    return React__default.createElement("option", {
      key: item.id,
      value: item.id
    }, item.name);
  })), React__default.createElement(Score, {
    current: selectedItem ? selectedItem.overall || 65 : defaultValue && defaultValue.overall
  }));
};

var icon$1 = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cdefs%3E%3Cstyle%3E.a%7Bopacity%3A0.6%3B%7D.b%7Bfill%3Anone%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20class%3D%22a%22%3E%3Cpath%20class%3D%22b%22%20d%3D%22M0%2C0H24V24H0Z%22%2F%3E%3Cpath%20d%3D%22M6.76%2C4.84%2C4.96%2C3.05%2C3.55%2C4.46%2C5.34%2C6.25ZM4%2C10.5H1v2H4ZM13%2C.55H11V3.5h2V.55Zm7.45%2C3.91L19.04%2C3.05%2C17.25%2C4.84l1.41%2C1.41Zm-3.21%2C13.7%2C1.79%2C1.8%2C1.41-1.41-1.8-1.79-1.4%2C1.4ZM20%2C10.5v2h3v-2Zm-8-5a6%2C6%2C0%2C1%2C0%2C6%2C6A6%2C6%2C0%2C0%2C0%2C12%2C5.5ZM11%2C22.45h2V19.5H11ZM3.55%2C18.54l1.41%2C1.41%2C1.79-1.8L5.34%2C16.74Z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  animation: rotation 5s infinite ease-in-out;\n  width: 80px;\n  height: 80px;\n  background-image: url(", ");\n  background-position: 50% 65%;\n  background-repeat: no-repeat;\n  background-size: 70px;\n\n  @keyframes rotation {\n    from {\n      -webkit-transform: rotate(0deg);\n    }\n    to {\n      -webkit-transform: rotate(360deg);\n    }\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var Sun = styled__default(components.Flex)(_templateObject$2(), icon$1);

var getOverallByName = function getOverallByName(countries, name) {
  var foundCountry = countries.find(function (country) {
    return country.name === name;
  });
  if (!foundCountry) return 65;
  return foundCountry.overall;
};

var getDisplayCountries = function getDisplayCountries(allCountries, countriesWithScores) {
  return allCountries.map(function (_ref) {
    var id = _ref.id,
        name = _ref.name;
    return {
      id: id,
      name: name,
      overall: getOverallByName(countriesWithScores, name)
    };
  });
};

var Widget = function Widget(_ref2) {
  var worldwide = _ref2.worldwide,
      industries = _ref2.industries,
      countries = _ref2.countries,
      defaultCountry = _ref2.defaultCountry,
      defaultIndustry = _ref2.defaultIndustry,
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? "Measure and improve workplace happiness" : _ref2$title,
      allCountries = _ref2.allCountries;

  var _useState = React.useState(null),
      selectedIndustry = _useState[0],
      setSelectedIndustry = _useState[1];

  var _useState2 = React.useState(null),
      selectedCountry = _useState2[0],
      setSelectedCountry = _useState2[1];

  var handleIndustrySelect = function handleIndustrySelect(id) {
    return setSelectedIndustry(industries.find(function (industry) {
      return industry.id === id;
    }));
  };

  var displayCountries = getDisplayCountries(allCountries, countries);

  var handleCountrySelect = function handleCountrySelect(id) {
    return setSelectedCountry(displayCountries.find(function (country) {
      return country.id === id;
    }));
  };

  var displayDefaultCountry = displayCountries.find(function (country) {
    return country.name === defaultCountry.name;
  });
  return React__default.createElement(components.Flex, {
    width: 1 / 1,
    flexDirection: "column",
    height: "100%"
  }, React__default.createElement(components.Flex, {
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between"
  }, React__default.createElement(components.Text, {
    fontSize: [3, 3, 4],
    color: "dark.2",
    fontWeight: "600",
    width: 2 / 3
  }, title), React__default.createElement(Sun, null)), React__default.createElement(components.Text, {
    color: "dark.2",
    fontSize: [3, 3, 4],
    fontWeight: "500",
    mb: 3
  }, "Today's scores:"), worldwide && React__default.createElement(Score, {
    mb: 2,
    current: worldwide,
    isGlobal: true
  }), industries && React__default.createElement(Dropdown, {
    type: "industry",
    onChange: handleIndustrySelect,
    items: industries,
    selectedItem: selectedIndustry,
    defaultValue: defaultIndustry && defaultIndustry
  }), countries && displayCountries && React__default.createElement(Dropdown, {
    type: "country",
    onChange: handleCountrySelect,
    items: displayCountries,
    selectedItem: selectedCountry,
    defaultValue: displayDefaultCountry
  }), React__default.createElement(components.Text, {
    color: "dark.2",
    fontSize: [1, 1, 2],
    fontWeight: "200",
    mb: 3
  }, "Data from ", React__default.createElement(routing.Link, {
    to: ssrConfig.getConfig().workL["public"]
  }, "WorkL")));
};

var mapState = function mapState(state, props) {
  return {
    worldwide: getWorldWide(state),
    countries: getCountries(state),
    industries: getIndustries(state),
    defaultCountry: getCountry(state, props),
    defaultIndustry: getIndustry(state, props)
  };
};

var WorkplaceHappiness = reactRedux.connect(mapState)(Widget);

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  animation: ", " 1.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) 0.2s infinite alternate\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var flash = styled.keyframes(["from{opacity:0;}to{opacity:1;}"]);
var AnimatedText = styled__default(components.Text)(_templateObject$3(), flash);

var LiveIcon = function LiveIcon() {
  return React__default.createElement(components.Flex, {
    width: 53,
    height: 25,
    alignItems: "center",
    justifyContent: "center",
    style: {
      borderColor: "#fe2c2c",
      borderWidth: 2,
      borderStyle: "solid"
    },
    borderRadius: 4,
    pl: 1
  }, React__default.createElement(AnimatedText, {
    textAlign: "center",
    color: "#fe2c2c",
    width: 1 / 1,
    height: "auto",
    mr: 1,
    fontFamily: "Roboto",
    fontWeight: 500
  }, "LIVE"));
};

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  border: none;\n  appearance: none;\n  width: 100%;\n  padding: ", "px 48px\n    ", "px ", "px;\n  background-image: url(", ");\n  background-position: center right ", "px;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  font-size: ", "px;\n  color: ", ";\n  border-radius: 4px 4px 0 0;\n  text-overflow: ellipsis;\n  margin: 0;\n\n  @media (min-width: ", "px) {\n    font-size: ", "px;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var Select$1 = styled__default.select(_templateObject$4(), function (_ref) {
  var theme = _ref.theme;
  return theme.space[3];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space[3];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space[3];
}, icon, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space[3];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.dark[7];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes[4];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.dark[2];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints[0];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes[3];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.dark[5];
});
/**
 * Renders a invisible form field label. The labels can't be seen,
 * but will be read out by a screen reader for visitors who use
 * assistive technologies.
 */

var HiddenLabel$1 = styled__default.label(_templateObject2$2());

var DropdownCircularProgress = function DropdownCircularProgress(_ref11) {
  var type = _ref11.type,
      _onChange = _ref11.onChange,
      items = _ref11.items,
      selectedItem = _ref11.selectedItem,
      defaultValue = _ref11.defaultValue;
  return React__default.createElement(components.Box, {
    bg: "light.0",
    mb: 2,
    borderRadius: 4,
    width: 1 / 1
  }, React__default.createElement(HiddenLabel$1, {
    htmlFor: type
  }, "Select ", type, ":"), React__default.createElement(Select$1, {
    key: defaultValue,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    id: "dropdown-" + type,
    defaultValue: defaultValue && defaultValue.id
  }, items.map(function (item) {
    return React__default.createElement("option", {
      key: item.id,
      value: item.id
    }, item.name);
  })), React__default.createElement(components.Flex, {
    alignItems: "center",
    justifyContent: "center",
    p: 2 //changed from 3
    ,
    borderRadius: 4,
    elevation: 2,
    bg: "light.0"
  }, React__default.createElement(components.Flex, {
    width: "auto"
  }, React__default.createElement(components.Flex, {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
  }, React__default.createElement(components.Paragraph, {
    textAlign: "center",
    width: "110px",
    fontSize: 3,
    color: "dark.1"
  }, "Average score"), defaultValue && React__default.createElement(charts.CircularProgress, {
    mb: 1,
    width: "60px",
    height: "60px",
    color: "primary.1",
    percentage: selectedItem ? selectedItem.overall || 65 : defaultValue && defaultValue.overall,
    strokeColor: "#00BB88",
    thickness: 0.5
  })))));
};

var ExternalLink = function ExternalLink(_ref) {
  var _ref$to = _ref.to,
      to = _ref$to === void 0 ? "/" : _ref$to,
      children = _ref.children;
  return React__default.createElement("a", {
    href: to,
    target: "_blank noopener norefferer"
  }, children);
};

var getOverallByName$1 = function getOverallByName(countriesWithScores, name) {
  if (!countriesWithScores) return 65;
  var foundCountry = countriesWithScores.find(function (country) {
    return country.name === name;
  });
  if (!foundCountry) return 65;
  return foundCountry.overall;
};

var getDisplayCountries$1 = function getDisplayCountries(allCountries, countriesWithScores) {
  return allCountries.map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name;
    return {
      id: id,
      name: name,
      overall: getOverallByName$1(countriesWithScores, name)
    };
  });
};

var HappinessSurveyWidget = function HappinessSurveyWidget(_ref3) {
  var worldwide = _ref3.worldwide,
      industries = _ref3.industries,
      countries = _ref3.countries,
      defaultCountry = _ref3.defaultCountry,
      defaultIndustry = _ref3.defaultIndustry,
      _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? "The Global Workplace Happiness Survey" : _ref3$title,
      _ref3$text = _ref3.text,
      text = _ref3$text === void 0 ? "Global Average Happiness Score" : _ref3$text,
      allCountries = _ref3.allCountries;
  var paths = routing.usePaths();

  var _useState = React.useState(null),
      selectedIndustry = _useState[0],
      setSelectedIndustry = _useState[1];

  var _useState2 = React.useState(null),
      selectedCountry = _useState2[0],
      setSelectedCountry = _useState2[1];

  var date = dateFns.format(new Date(), "do MMMM yyyy");

  var handleIndustrySelect = function handleIndustrySelect(id) {
    return setSelectedIndustry(industries.find(function (industry) {
      return industry.id === id;
    }));
  };

  var displayCountries = getDisplayCountries$1(allCountries, countries);

  var handleCountrySelect = function handleCountrySelect(id) {
    return setSelectedCountry(displayCountries.find(function (country) {
      return country.id === id;
    }));
  };

  var displayDefaultCountry = displayCountries.find(function (country) {
    return defaultCountry && country.name === defaultCountry.name;
  });
  return React__default.createElement(components.Flex, {
    flexDirection: "column",
    alignItems: "center"
  }, React__default.createElement(components.Flex, null, React__default.createElement(components.Paragraph, {
    color: "dark.2",
    fontSize: 4,
    width: 1 / 1,
    fontWeight: 600
  }, title), React__default.createElement(LiveIcon, null)), React__default.createElement(components.Paragraph, {
    color: "dark.2"
  }, date), React__default.createElement(components.Box, {
    bg: "light.0",
    width: 1 / 1,
    height: "auto",
    elevation: 1,
    borderRadius: 5,
    padding: 3
  }, React__default.createElement(components.Flex, {
    width: 1 / 1
  }, React__default.createElement(components.Paragraph, {
    textAlign: "center",
    fontSize: 3,
    color: "dark.1",
    mt: "auto",
    mb: "auto"
  }, text), React__default.createElement(charts.CircularProgress, {
    height: "60px",
    color: "primary.1",
    percentage: worldwide || 0,
    strokeColor: "#00BB88",
    thickness: 0.5
  }))), React__default.createElement(components.Flex, {
    width: 1 / 1,
    flexDirection: ["column", "row"],
    justifyContent: "space-between"
  }, React__default.createElement(components.Flex, {
    flexDirection: "column",
    width: 1 / 1
  }, React__default.createElement(components.Paragraph, {
    mt: 3,
    color: "dark.2",
    fontSize: 3
  }, "By Country"), React__default.createElement(components.Box, {
    width: ["100%", "96%"],
    height: "auto",
    mr: [1, 2],
    mt: -2
  }, countries && displayCountries && React__default.createElement(DropdownCircularProgress, {
    type: "country",
    onChange: handleCountrySelect,
    items: displayCountries || [],
    selectedItem: selectedCountry,
    defaultValue: displayDefaultCountry
  }))), React__default.createElement(components.Flex, {
    flexDirection: "column"
  }, React__default.createElement(components.Paragraph, {
    ml: 1,
    mt: 3,
    color: "dark.2",
    fontSize: 3
  }, "By Sector"), React__default.createElement(components.Box, {
    width: ["100%", "96%"],
    height: "auto",
    ml: [1, 2],
    mt: -2
  }, industries && React__default.createElement(DropdownCircularProgress, {
    type: "industry",
    onChange: handleIndustrySelect,
    items: industries || [],
    selectedItem: selectedIndustry,
    defaultValue: defaultIndustry
  })))), React__default.createElement(components.Paragraph, {
    my: 3,
    fontSize: 4,
    color: "dark.2"
  }, "We\u2019ve teamed up with The Telegraph to find the happiest places to work in the UK."), React__default.createElement(components.Paragraph, {
    mb: 3,
    fontSize: 4,
    color: "dark.2"
  }, "Rankings are based on the data collected through our free Workplace Happiness Survey provided by", " ", React__default.createElement(ExternalLink, {
    color: "primary.0",
    to: ssrConfig.getConfig().workL["public"]
  }, React__default.createElement(components.Text, {
    fontSize: 4,
    color: "#F06800"
  }, "WorkL"))), React__default.createElement(ExternalLink, {
    to: ssrConfig.getConfig().workL.app + "/find-work/happiest-companies"
  }, React__default.createElement(components.Button, {
    variant: "primary.0",
    width: "226px",
    mb: 2
  }, "VIEW HAPPY COMPANIES")));
};

var mapState$1 = function mapState(state, props) {
  return {
    worldwide: getWorldWide(state),
    countries: getCountries(state),
    industries: getIndustries(state),
    defaultCountry: getCountry(state, props),
    defaultIndustry: getIndustry(state, props)
  };
};

var HappinessSurveyWidget$1 = reactRedux.connect(mapState$1)(HappinessSurveyWidget);

var ageGroup = [{
  key: "18-",
  text: "Under 18"
}, {
  key: "19-24",
  text: "19-24"
}, {
  key: "25-34",
  text: "25-34"
}, {
  key: "35-44",
  text: "35-44"
}, {
  key: "45-54",
  text: "45-54"
}, {
  key: "55-64",
  text: "55-64"
}, {
  key: "65+",
  text: "65+"
}];
var genders = ["Male", "Female", "Other"];
var selectedItems = {
  ageGroup: "all",
  gender: "all"
};

var selectAgeGroup = function selectAgeGroup(event) {
  selectedItems.ageGroup = event.target.value;
};

var selectGender = function selectGender(event) {
  selectedItems.gender = event.target.value;
};

var DemographicsDialog = function DemographicsDialog(_ref) {
  var isVisible = _ref.isVisible,
      onSetFilters = _ref.onSetFilters,
      onToggle = _ref.onToggle;
  return isVisible && React__default.createElement(components.Dialog, {
    header: "Set Demographics To Find Happy Jobs For You",
    onToggle: onToggle,
    footer: [{
      label: "Set Demographic",
      action: function action() {
        return onSetFilters(selectedItems);
      }
    }, {
      label: "Cancel",
      action: onToggle
    }]
  }, React__default.createElement(components.Box, null, React__default.createElement(components.Paragraph, {
    color: "dark.2",
    mt: 2,
    mb: 3,
    fontSize: 5,
    textAlign: "center"
  }, "Find the happiest jobs for your demographic profile, such as happiest companies or industries for a diverse workforce."), React__default.createElement(components.Box, {
    mt: 3
  }, React__default.createElement(components.Select, {
    name: "ageGroup",
    id: "ageGroup",
    label: "Age Groups",
    onChange: selectAgeGroup
  }, React__default.createElement("option", {
    key: "all",
    value: "all"
  }, "All"), ageGroup.map(function (item) {
    return React__default.createElement("option", {
      selected: selectedItems.ageGroup === item.key,
      key: item.key,
      value: item.key
    }, item.text);
  }))), React__default.createElement(components.Box, {
    mt: 3
  }, React__default.createElement(components.Select, {
    name: "gender",
    id: "gender",
    label: "Genders",
    onChange: selectGender
  }, React__default.createElement("option", {
    key: "all",
    value: "all"
  }, "All"), genders.map(function (text) {
    return React__default.createElement("option", {
      selected: selectedItems.gender === text.toLowerCase(),
      key: text,
      value: text.toLowerCase()
    }, text);
  })), React__default.createElement(components.Paragraph, {
    fontSize: 2,
    color: "dark.2"
  }, "* This information is taken from your profile"))));
};

exports.DemographicsDialog = DemographicsDialog;
exports.HappinessActions = happiness_actions;
exports.HappinessSelectors = happiness_selectors;
exports.HappinessSurveyWidget = HappinessSurveyWidget$1;
exports.WorkplaceHappiness = WorkplaceHappiness;
exports.happinessReducer = reducer;
exports.happinessSaga = saga;
